import { hot } from "react-hot-loader/root";
import React, { useState, Suspense } from "react";
import ContextOffcanvas from "./contexts/offcanvas-context";
import ContextUser from "./contexts/user-context";
import ComponentSiteheader from "./layouts/siteheader/index";
import ComponentSitefooter from "./layouts/sitefooter/index";
import ComponentSitefooterTKL from "./layouts/sitefootertkl/index";
import ComponentSiteheaderTKL from "./layouts/siteheadertkl";

import ComponentSitenav from "./layouts/sitenav/index";
import ComponentOffcanvas from "./offcanvas/index";
import ComponentContentLoader from "./shared-components/page-loader/index-content";
//  import OffcanvasUserAccount from "./offcanvas/templates/user-account"
import { withRouter } from "react-router-dom";
import { IS_UNDER_MAINTENANCE } from "./api/tklEnvironments";
import {
  _AddClass,
  _HasClass,
  _RemoveClass,
} from "./shared/services/constants";

import 'react-image-crop/dist/ReactCrop.css'
import history from "./Routes/history";
import MainRoutes from "./Routes/mainRoutes";
import "./App.scss";
import { Provider, connect } from "react-redux";
import configureStore from "./store/index";
import { getProfileData } from "./actions/UserActions/ProfileActions";
import { useDispatch, useSelector } from "react-redux";
import { getNotifications } from "./actions/Notification/NotificationActions";
import LogRocket from "logrocket";
export const store = configureStore({});
const OffcanvasChangeEmail = React.lazy(() =>
  import("./offcanvas/templates/change-email")
);
const OffcanvasChangePassword = React.lazy(() =>
  import("./offcanvas/templates/change-password")
);
const OffcanvasCourseSettings = React.lazy(() =>
  import("./offcanvas/templates/course-settings")
);
const OffcanvasCreateCohort = React.lazy(() =>
  import("./offcanvas/templates/create-cohort")
);
const OffcanvasCatalogFilters = React.lazy(() =>
  import("./offcanvas/templates/catalog-filters")
);
const OffcanvasUserAccount = React.lazy(() =>
  import("./offcanvas/templates/user-account")
);

import TKLErrorBoundary from "./TKLErrorBoundary";

// ContextUser.Provider sits inside App's inner Redux Provider. Read bio from that
// store — getProfileData() writes here (PL-10/27). App's own useSelector is the
// outer index.js store, which never gets roles, so instructor review hid Provide Feedback.
function ContextUserFromStore({ isloggedin, dologout, history, children }) {
  const userData = useSelector((state) => state.users.userData);
  return (
    <ContextUser.Provider
      value={{
        isloggedin,
        dologout,
        history,
        userProfileData: userData,
      }}
    >
      {children}
    </ContextUser.Provider>
  );
}

const INTERCOM_APP_ID = "bfs7f7yw";
const INTERCOM_API_BASE = "https://api-iam.intercom.io";

function ensureIntercomWidget() {
  const w = window;
  if (typeof w.Intercom !== "function") {
    const i = function () {
      i.c(arguments);
    };
    i.q = [];
    i.c = function (args) {
      i.q.push(args);
    };
    w.Intercom = i;
  }
  if (
    document.getElementById("intercom-widget-script") ||
    document.querySelector('script[src*="widget.intercom.io"]')
  ) {
    return;
  }
  const loadWidget = function () {
    if (
      document.getElementById("intercom-widget-script") ||
      document.querySelector('script[src*="widget.intercom.io"]')
    ) {
      return;
    }
    const s = document.createElement("script");
    s.id = "intercom-widget-script";
    s.type = "text/javascript";
    s.async = true;
    s.src = "https://widget.intercom.io/widget/" + INTERCOM_APP_ID;
    const x = document.getElementsByTagName("script")[0];
    if (x && x.parentNode) {
      x.parentNode.insertBefore(s, x);
    } else if (document.head) {
      document.head.appendChild(s);
    }
  };
  if (typeof w.__tklDeferThirdParty === "function") {
    w.__tklDeferThirdParty(loadWidget);
  } else if (document.readyState === "complete") {
    loadWidget();
  } else {
    w.addEventListener("load", loadWidget, false);
  }
}

// Must live inside App's inner <Provider> — that store is where get-user-bio lands.
function IntercomIdentity() {
  const userData = useSelector((state) => state.users.userData);

  React.useEffect(() => {
    const hasToken = Boolean(
      typeof localStorage !== "undefined" && localStorage.getItem("token")
    );
    const email = (userData?.email || "").trim();
    const userId = userData?.userId;
    const hasUserId = userId != null && userId !== "";
    const name = [userData?.firstName, userData?.middleName, userData?.lastName]
      .filter(Boolean)
      .join(" ")
      .trim();

    if (!hasToken || (!email && !hasUserId)) {
      return;
    }

    const settings = {
      api_base: INTERCOM_API_BASE,
      app_id: INTERCOM_APP_ID,
    };
    if (email) {
      settings.email = email;
    }
    if (hasUserId) {
      settings.user_id = String(userId);
    }
    if (name) {
      settings.name = name;
    }

    window.intercomSettings = settings;
    const alreadyStarted = typeof window.Intercom === "function";
    ensureIntercomWidget();
    if (typeof window.Intercom !== "function") {
      return;
    }
    if (window.__tklIntercomIdentified || alreadyStarted) {
      window.Intercom("update", settings);
    } else {
      window.Intercom("boot", settings);
    }
    window.__tklIntercomIdentified = true;
  }, [userData]);

  return null;
}

function App(props) {
  const dispatch = useDispatch();
  const { notification } = useSelector((state) => state.notifications);

  React.useEffect(() => {
    //console.log("notifications: ", notification);
  }, [notification]);

  let bodyElem;
  if (window && document) {
    bodyElem = document.getElementsByTagName("body")[0];
  }

  const toggleSiteNav = (val) => {
    setSitenavToggle(val);
  };
  const toggleOffcanvas = (val, child, title) => {
    setOffcanvasToggle(val);
    setOcChild(child ? child : "");
    setOcTitle(child && title ? title : "");
  };

  const windowNavigation = (event) => {
    toggleSiteNav(false);
    toggleOffcanvas(false, null, null);
  };

  const dologin = () => {
    setIsloggedin(true);
  };
  const dologout = () => {
    setIsloggedin(false);
  };

  const [sitenavToggle, setSitenavToggle] = useState(false);
  const [offcanvasToggle, setOffcanvasToggle] = useState(false);
  const [ocChild, setOcChild] = useState("");
  const [ocTitle, setOcTitle] = useState("");
  const [isWindowPopAttached, setIsWindowPopAttached] = useState(false);
  const [isloggedin, setIsloggedin] = useState(true);
  const userLogggedIn = useSelector((state) => state.auth.isLoggedIn);
  const userData = useSelector((state) => state.users.userData);

  //console.log("userData ::::", JSON.parse(JSON.stringify(userData)));

  React.useEffect(() => {
    setIsloggedin(userLogggedIn);
  }, [userLogggedIn]);

  React.useEffect(() => {
    if (window && document && !isWindowPopAttached) {
      setIsWindowPopAttached(true);
      window.addEventListener("popstate", windowNavigation);
    }
    if ((sitenavToggle || offcanvasToggle) && bodyElem) {
      _AddClass(bodyElem, "overflow-hidden");
    } else {
      _RemoveClass(bodyElem, "overflow-hidden");
    }
  }, [sitenavToggle, offcanvasToggle]);

  const closeCanvas = () => {
    setOffcanvasToggle(false);
  };
  React.useMemo(() => {
    if (localStorage.getItem("token")) {
      // Must use App's store (inner Provider) — outer index.js Provider is a different instance
      store.dispatch(getProfileData());
    }
  }, []);

  React.useMemo(() => {
    // logRocket
    if (process.env.REACT_APP_ENVIRONMENT.trim() == "prod") {
      console.log(
        "process.env.REACT_APP_ENVIRONMENT.trim()",
        process.env.REACT_APP_ENVIRONMENT.trim() == "prod"
      );
      LogRocket.init("efhkxm/tkl");
      LogRocket.identify(userData.email, { userData });
    }

    //RollBar
    // Set the person data and custom data to be sent with all errors for this notifier.
    if (process.env.REACT_APP_ENVIRONMENT.trim() == "prod") {
      console.log("rollbar runnning in prod APP.js");
      // LogRocket.getSessionURL((sessionURL) => {
      //   Rollbar.configure({
      //     transform: function (obj) {
      //       obj.sessionURL = sessionURL;
      //     },
      //   });
      // });
      // Rollbar.configure({
      //   payload: {
      //     person: {
      //       id: userData?.userId,
      //       username:
      //         (userData?.firstName || "") +
      //         (" " + userData?.middleName || "") +
      //         (" " + userData?.lastName || ""),
      //       email: userData.email,
      //     },
      //     custom: {
      //       userData: userData,
      //     },
      //   },
      // });
    }
  }, [userData]);

  return (
    <React.Fragment>
      <TKLErrorBoundary>
      {/* Avoid connected LogoLoader here — it imports App store and blanks the tree */}
      <React.Suspense fallback={<ComponentContentLoader />}>
        <Provider store={store}>
          <IntercomIdentity />
          {/* <ComponentSiteheader toggleSiteNav={toggleSiteNav} />
          <MainRoutes isloggedin={isloggedin} dologin={dologin}></MainRoutes>
          <ComponentSitefooter /> */}
          {/* <ComponentSitenav
            isToggled={sitenavToggle}
            toggleSiteNav={toggleSiteNav}
            toggleOffcanvas={toggleOffcanvas}
          />
          <ComponentOffcanvas
            isToggled={offcanvasToggle}
            toggleOffcanvas={toggleOffcanvas}
            title={ocTitle}
          ></ComponentOffcanvas> */}
          <ContextUserFromStore
            isloggedin={isloggedin}
            dologout={dologout}
            history={history}
          >
            <ContextOffcanvas.Provider value={toggleOffcanvas}>
              <>
                <div className="root-app">
                  {isloggedin && !IS_UNDER_MAINTENANCE ? (
                    history?.location?.hash.includes("external-catalog") ||
                    history?.location?.hash.includes("external-catalog") ? (
                      <ComponentSiteheaderTKL />
                    ) : (
                      <ComponentSiteheader
                        toggleSiteNav={toggleSiteNav}
                        notification={notification}
                      />
                    )
                  ) : !IS_UNDER_MAINTENANCE ? (
                    <ComponentSiteheaderTKL />
                  ) : (
                    ""
                  )}
                  <MainRoutes
                    isUnderMaintenance={IS_UNDER_MAINTENANCE}
                    isloggedin={isloggedin}
                    dologin={dologin}
                  ></MainRoutes>
                  {isloggedin ? (
                    history?.location?.hash.includes("external-catalog") ||
                    history?.location?.hash.includes("external-catalog") ? (
                      <ComponentSitefooterTKL />
                    ) : (
                      <ComponentSitefooter />
                    )
                  ) : (
                    <ComponentSitefooterTKL />
                  )}
                </div>
                {(isloggedin &&
                  !history?.location?.hash.includes("external-catalog")) ||
                history?.location?.hash.includes("external-catalog") ? (
                  <>
                    <div className="root-offcanvas">
                      {!IS_UNDER_MAINTENANCE ? (
                        <ComponentSitenav
                          isToggled={sitenavToggle}
                          toggleSiteNav={toggleSiteNav}
                          toggleOffcanvas={toggleOffcanvas}
                        />
                      ) : (
                        ""
                      )}
                      <ComponentOffcanvas
                        isToggled={offcanvasToggle}
                        toggleOffcanvas={toggleOffcanvas}
                        title={ocTitle}
                      >
                        {ocChild === "OffcanvasCourseSettings" ? (
                          <Suspense fallback={<ComponentContentLoader />}>
                            <OffcanvasCourseSettings />
                          </Suspense>
                        ) : (
                          <></>
                        )}
                        {ocChild === "OffcanvasChangeEmail" ? (
                          <Suspense fallback={<ComponentContentLoader />}>
                            <OffcanvasChangeEmail />
                          </Suspense>
                        ) : (
                          <></>
                        )}
                        {ocChild === "OffcanvasChangePassword" ? (
                          <Suspense fallback={<ComponentContentLoader />}>
                            <OffcanvasChangePassword />
                          </Suspense>
                        ) : (
                          <></>
                        )}
                        {ocChild === "OffcanvasCreateCohort" ? (
                          <Suspense fallback={<ComponentContentLoader />}>
                            <OffcanvasCreateCohort />
                          </Suspense>
                        ) : (
                          <></>
                        )}
                        {ocChild === "OffcanvasCatalogFilters" ? (
                          <Suspense fallback={<ComponentContentLoader />}>
                            <OffcanvasCatalogFilters />
                          </Suspense>
                        ) : (
                          <></>
                        )}
                        {ocChild === "OffcanvasUserAccount" ? (
                          <Suspense fallback={<ComponentContentLoader />}>
                            <OffcanvasUserAccount closeCanvas={closeCanvas} />
                          </Suspense>
                        ) : (
                          <></>
                        )}
                      </ComponentOffcanvas>
                    </div>
                  </>
                ) : (
                  <></>
                )}
              </>
            </ContextOffcanvas.Provider>
          </ContextUserFromStore>
        </Provider>
      </React.Suspense>
      </TKLErrorBoundary>
      
    </React.Fragment>
  );
}

// const mapStateToProps = (state) => {
//   return {
//     isLoading: state.coursehome.isLoading,
//   };
// };
// const mapDispatchToProps = (dispatch) => {
//   return {};
// };
// export default connect(mapStateToProps, mapDispatchToProps)(App);
export default App;
